"use strict";

import _classCallCheck from "/Users/hmd/Documents/git/EAR-PreSales/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/hmd/Documents/git/EAR-PreSales/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/hmd/Documents/git/EAR-PreSales/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/hmd/Documents/git/EAR-PreSales/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { getAddress } from "@ethersproject/address";
import { hexZeroPad } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder";
export var AddressCoder = /*#__PURE__*/function (_Coder) {
  _inherits(AddressCoder, _Coder);

  var _super = _createSuper(AddressCoder);

  function AddressCoder(localName) {
    _classCallCheck(this, AddressCoder);

    return _super.call(this, "address", "address", localName, false);
  }

  _createClass(AddressCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      try {
        getAddress(value);
      } catch (error) {
        this._throwError(error.message, value);
      }

      return writer.writeValue(value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return getAddress(hexZeroPad(reader.readValue().toHexString(), 20));
    }
  }]);

  return AddressCoder;
}(Coder);